import { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import { usePageConfigState } from 'hooks/usePageConfig'
import { getPageConfig } from 'features/config/asyncThunks'
import { isFulfilled } from '@reduxjs/toolkit'
import i18n from 'i18n'

const useRetrievePageConfig = () => {
  const dispatch = useAppDispatch()

  const config = usePageConfigState()

  useEffect(() => {
    const fetchPageConfig = async () => {
      const res = await dispatch(getPageConfig())

      // * set language after fetching page config
      if (isFulfilled(res) && res.payload?.pageConfig?.user?.locale === 'ja_JP') {
        i18n.changeLanguage('ja')
      }
    }
    fetchPageConfig()
  }, [dispatch])

  return config
}

export default useRetrievePageConfig
